module.exports = __webpack_public_path__ + "img/monitor.e7b680a3.png";